export { default } from "./NumericBadge";
